import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Music2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const r = await register(form);
    setBusy(false);
    if (r.ok) nav("/dashboard");
    else setErr(r.error);
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-6 py-12 bg-black">
      <div className="w-full max-w-lg bg-ink-900 border border-ink-700 p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 border border-gold flex items-center justify-center"><Music2 className="text-gold" /></div>
          <div className="font-heading text-3xl"><span className="text-white">Song</span><span className="text-gold">niture</span></div>
        </div>
        <h1 className="font-heading text-2xl mb-1">Create Account</h1>
        <p className="text-white/60 text-sm mb-6">Order custom branded music for your business</p>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="label">Full Name</label>
              <input required className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
            </div>
            <div>
              <label className="label">Company</label>
              <input className="input" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} data-testid="register-company" />
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="label">Email</label>
              <input required type="email" className="input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
            </div>
            <div>
              <label className="label">Phone</label>
              <input className="input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="register-phone" />
            </div>
          </div>
          <div>
            <label className="label">Password</label>
            <input required type="password" minLength={6} className="input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
          </div>
          {err && <div className="text-destructive text-sm" data-testid="register-error">{err}</div>}
          <button disabled={busy} className="btn-gold w-full justify-center" data-testid="register-submit">
            {busy ? "Creating…" : "Create Account"}
          </button>
        </form>
        <div className="mt-6 text-sm text-white/60 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-gold hover:underline" data-testid="register-to-login">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
